import "./App.css";
import Homepage from "./pages/Homepage";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./styles/style.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import Register from "./pages/Register";
import LoginPage from "./pages/LoginPage";
import NotFound from "./pages/NotFound";
import { Authentication } from "./useAuth";
import { ProfilePage } from "./pages/ProfilePage";
import AppAuth from "./AppAuth";
import RequireAuth from "./Components/global/RequireAuth";
import CarouselManager from "./pages/CarouselManager";
import CategoryManager from "./pages/CategoryManager";
import GalleryManager from "./pages/GalleryManager";
import TestimonialManager from "./pages/TestimonialManager";
import UsersManagement from "./pages/UsersManagement";
import BookingRequests from "./pages/BookingRequests";
import PricingManager from "./pages/PricingManager";


export default function App() {
  const Scroll = (props) => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
    return props.children;
  };

  return (
    <div>
      <ToastContainer position="top-right" />
      <Authentication>
        <Scroll>
          <div className="text-sm text-slate-600">
            <Routes>
              <Route path="login" element={<LoginPage />} />
              <Route path="register" element={<Register />} />
              <Route path="*" element={<NotFound />} />
              <Route path="/" element={<Navigate to="/my" />} />
              <Route path="/my" element={<AppAuth />}>
                {/* <Route path="" element={<Homepage />} /> */}
                <Route path="" element={<CarouselManager />} />
                <Route path="profile" element={<ProfilePage />} />

                {/* Contents Manager */}
                <Route
                  path="carouselManager"
                  element={
                    <RequireAuth
                      component={<CarouselManager />}
                      userTypes={["admin", "telecaller"]}
                    />
                  }
                />

                <Route
                  path="categoryManager"
                  element={
                    <RequireAuth
                      component={<CategoryManager />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="galleryManager"
                  element={
                    <RequireAuth
                      component={<GalleryManager />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="testimonialManager"
                  element={
                    <RequireAuth
                      component={<TestimonialManager />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="usersManagement"
                  element={
                    <RequireAuth
                      component={<UsersManagement />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="bookingRequests"
                  element={
                    <RequireAuth
                      component={<BookingRequests />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="pricingManager"
                  element={
                    <RequireAuth
                      component={<PricingManager />}
                      userTypes={["admin"]}
                    />
                  }
                />

              </Route>
            </Routes>
          </div>
        </Scroll>
      </Authentication>
    </div>
  );
}
